import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// CSR-1404 — the only asset lifecycle state a CSR can set directly: Active
// (removedAt cleared) or Removed (removedAt stamped). "Inactive" is derived from
// an expired policy term, not user-settable, so it is intentionally not offered.
export type AssetLifecycleStatus = "active" | "removed";

interface Props {
  value: AssetLifecycleStatus;
  onChange: (value: AssetLifecycleStatus) => void;
  testId?: string;
}

export function AssetStatusSelect({ value, onChange, testId }: Props) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as AssetLifecycleStatus)}>
      <SelectTrigger id={testId} data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="active">Active</SelectItem>
        <SelectItem value="removed">Removed</SelectItem>
      </SelectContent>
    </Select>
  );
}
